export default () => {
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-speech-bubble]')) {
      const speechBubbles = document.querySelectorAll('[data-speech-bubble]');
      speechBubbles.forEach((bubble) => bubble.classList.remove('revealed'));
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-speech-bubble-toggle]')) {
      event.preventDefault();
      event.stopPropagation();

      const speechBubble = event.target.querySelector('[data-speech-bubble]');
      if (speechBubble) {
        speechBubble.classList.toggle('revealed');
      }
    }
  });
};
